'use strict';

function VerifyBank() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _BankController];
  this._modelsReady = 0;
  this._modelsRequired = 2;
  this._bankModelsReady = false;
  this._loanModelReady = false;
  this._CHECK_BANK_NAME = 'CheckBank';
  this._forceRelink = false; // user selected the same bank so they probably want to switch accounts  (or they were just checking things out)
  this.existingLoanAccount = null;

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[VerifyBank]';

  this.init = function () {
    this._super();
    this.getBankList(this._onBankModelsReady.bind(this));
  };

  this.initAllReady = function () {
    this._super();
  };

  // This initPage() function is called via the MoneyController
  // when all the data models are ready.
  this.initPage = function () {
    var _this = this;

    if (this._DEBUG) console.log(this.pageName + ' - initPage() Called');

    // Cache selectors
    this._$loader = $('.js--longform-information__loader');
    this._$plaidSupportedContent = $('.js--longform-information__section');
    this._$dltSupportedContent = $('.js--longform-dlt-information__section');
    this._$dltSupportedContentConnectCta = $('.js--connect-bank-dlt-cta');
    this._$dltActiveState = $('.js--dlt-active-state');
    this._$dltActiveStateContinueCta = $('.js--continue-dlt-cta');
    this._$dltActiveStateChatCta = $('.js--chat-cta');
    this._$confirmBankDialog = $('.js--confirm-bank-dialog');
    this._$confirmBankDialogCta = $('.js--confirm-bank-dialog-cta');
    this._$cancelDialogCta = $('.js--cancel-dialog-cta');
    this._$exitVerifyDialog = $('.js--exit-verify-dialog');
    this._$exitVerifyDialog.find('.icon--close').attr('data-analytics-id', 'Money-ABS-Upload Bank Statements Instead Close-Null-Click');
    this._$exitDialogCta = $('.js--exit-dialog-cta');
    this._$verifySelectedBank = $('.js--verify-selected-bank');
    this._$checkBankComponent = $('.js--check-bank-selection');
    this._$checkBankCta = $('.js--check-bank-cta');
    this._$selectAnotherBankSection = $('.js--select-new-bank-section');
    this._$duplicateAccountCta = $('.js--execute-statement-pull');

    // ABV STATUS CHECK - will redirect from this page if already Submitted
    var bvStatus = this._getBankVerificationStatus();
    if (bvStatus) bvStatus = bvStatus.status;
    var bvSubmitted = bvStatus === 'submitted' || bvStatus === 'failed' || bvStatus === 'verified';
    if (bvSubmitted) {
      // do not allow user to verify bank here if they have already attempted to do so
      window.location.replace('/portal/dashboard?arn=true');
      return;
    }

    // Models ready at this point (via extended controllers)
    this._onLoansModelReady();

    // Check to see if DLT code generated - Show DLT in progress state if it is
    if (this._getDLTCode()) {
      if (this._DEBUG) console.log(this.pageName + ' - getDLTCode() inside initPage() Called');

      this._$verifySelectedBank.hide();
      this._$dltActiveState.show();

      this._setupDLTStateBindEvents(this._getDLTCode);
    }

    this._setupLivechat();

    // -----------
    // Bind events
    // ------------

    // CTA: 'No not that one' - Toggles Select New Bank State
    this._$checkBankCta.on('click', this._selectNewBank.bind(this));

    // CTA: Connect Bank -  DLT State - Toggles DLT Flow
    this._$dltSupportedContentConnectCta.on('click', this._onConnectBankViaDlt.bind(this));

    // CTA: Connect Bank - Plaid State - Toggles Confirm bank Popup
    this._$confirmBankDialogCta.on('click', function () {
      _this._$confirmBankDialog.mogo().show();
      _this.presenter.scanDOM(_this._$confirmBankDialog);
    });

    // ------------------------------
    // Confirm bank Popup bind events
    // ------------------------------
    this._$confirmBankDialog.find('.icon--close').attr('data-analytics-id', 'Money-ABS-Looks Good Close-Null-Click');

    this._$exitDialogCta.on('click', function () {
      _this._$exitVerifyDialog.mogo().show();
    });

    this._$cancelDialogCta.on('click', function (event) {
      $(event.currentTarget).closest('[data-mogo-ui="Dialog"]').mogo().hide();
    });
  };

  // These CTAS show up if page is in DLT in Progress State
  this._setupDLTStateBindEvents = function (getDLTCode) {
    // Continue DLT CTA
    this._$dltActiveStateContinueCta.on('click', function () {
      var dltCode = getDLTCode();
      if (dltCode) {
        var dltPage = 'https://www.decisionlogic.com/' + dltCode;
        window.open(dltPage, '_blank'); // open dlt page in new tab
      } else {
        console.warn('this.getDLTCode() returned false');
      }
    });

    // Chat with us CTA
    this._$dltActiveStateChatCta.on('click', function () {
      // Triggers help and support link in the sidebar which opens the chat bubble
      $('.js--memberNav__help-link')[0].click();
    });
  };

  // This is only called in Mini Flow
  this._generateDLTCode = function (id, callbacks) {
    var _this2 = this;

    if (this._DEBUG) console.log(this.pageName + ' _generateDLTCode() called');

    if (this.presenter.hasAction('banking.accounts.generate_dlt_code')) {
      this.presenter.performAction('banking.accounts.generate_dlt_code', null, function (data, response) {
        if (response === 200) {
          if (_this2._DEBUG) {
            console.log(_this2.pageName + ' rel link - banking.accounts.generate_dlt_code Success');
          }
          var dltCode = data.dlt_code;
          if (dltCode) {
            _this2._updateFSBankAccountModel(dltCode);
          } else {
            console.warn('Missing dlt_code key in data object.');
          }
        } else {
          console.warn('Error calling rel link - banking.accounts.generate_dlt_code: ' + JSON.stringify(data) + ', ' + response);
          failureCallback(data, response);
        }
      });
    } else {
      console.warn('Missing rel-link: banking.accounts.generate_dlt_code');
    }
  };
  /*
   This property comes from in the FS app customer bank accounts table 
   dlt_code property is on this model if present
  */
  this._updateFSBankAccountModel = function (dltCode) {
    var FSBankAccount = this.presenter.getModelProperty('money.loans.fs_loans.bank_account');

    if (!FSBankAccount) {
      console.warn('No FS bank Account object -  money.loans.fs_loans.bank_account');
    } else {
      this.presenter.setModelProperty('money.loans.fs_loans.bank_account.dlt_code', dltCode);
      this._openDLTLinkAndReload(dltCode);
    }
  };

  this._openDLTLinkAndReload = function (dltCode) {
    if (this._DEBUG) console.log(this.pageName + ' _openDLTLinkAndReload() called');

    // DLT here
    var dltPage = 'https://www.decisionlogic.com/' + dltCode;
    window.open(dltPage, '_blank');

    // Location current page (Makes this page go into DLT in progress state)
    location.reload();
  };

  this._pushAnalytics = function (isOnline) {
    var pageViewUrl = window.location.href + '-Bank';
    var prependUrl = isOnline ? 'Online' : 'Offline';
    if (this._forceRelink) {
      pageViewUrl += 'Confirm';
    } else {
      pageViewUrl += 'No';
    }
    this.analytics.pushEvent('virtual-page-view', { Page: [pageViewUrl + prependUrl] });
  };

  this.destroy = function () {
    this._removeComputed();

    if (!this._$checkBankComponent.mogo().create) {
      this._$checkBankComponent.mogo().destroy();
    }
    this._$confirmBankDialog.mogo().destroy();

    if (!this._$exitVerifyDialog.mogo().create) {
      this._$exitVerifyDialog.mogo().destroy();
    }
  };

  //  Returns DLT code if it has been generated
  // from the FS loans bank account object
  this._getDLTCode = function () {
    if (mogo.registry.mogoUI.repo.Portal.presenter.models.money.loans.fs_loans.bank_account.dlt_code) {
      return mogo.registry.mogoUI.repo.Portal.presenter.getModelProperty('money.loans.fs_loans.bank_account.dlt_code');
    } else {
      if (this._DEBUG) console.log(this.pageName + ' _getDLTCode() returned false');

      return false;
    }
  };

  this._onBankModelsReady = function () {
    this._modelsReady += 1;
    this._bankModelsReady = true;
    if (this._modelsReady >= this._modelsRequired) this._allDependantsReady();
  };

  this._onLoansModelReady = function () {
    this._modelsReady += 1;
    this._loanModelReady = true;
    if (this._modelsReady >= this._modelsRequired) this._allDependantsReady();
  };

  this._allDependantsReady = function () {
    var _this3 = this;

    if (this._bankModelsReady && this._loanModelReady) {
      this.getBankAccountsAssociatedWithProducts(BankAccount.productType.loan, function (accts) {
        if (accts && accts.length > 0) _this3.existingLoanAccount = accts[0];
        _this3._setupPreBankSelectionCheck();
      });
    }
  };

  // Check online/supported for Plaid, also check DLT supported
  this._setupPreBankSelectionCheck = function () {
    var callbacks = {};
    callbacks.onStatusOffline = this._manualUploadCallback.bind(this);
    callbacks.onStatusNotSupported = this._manualUploadCallback.bind(this);
    callbacks.onStatusOnline = this._linkAndPullCallback.bind(this);
    callbacks.onDltSupported = this._dltSupportedCallback.bind(this);
    var fsBank = this.FSBankAccount(); // From MoneyController

    // check plaid bank status
    this.bankPlaidStatusCheck(fsBank, callbacks);
  };

  this._matchedBanksOnlineCallback = function () {
    var _this4 = this;

    // force link_and_pull if the user chooses the same bank again
    var _selectedBank = this.presenter.getModelProperty('bankSelected.id');
    var spendingAccountIndex = this.spendingBankAccount._getAccountArrayIndex();
    if (this._forceRelink === _selectedBank) {
      this._linkAndPullCallback();
    } else if (this.spendingBankAccount.isLinked()) {
      this._pushAnalytics(true);
      this._$duplicateAccountCta.on('click', function (e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false; // because garbage IE
        $(e.currentTarget).mogo().setDisabledLoadState();
        _this4.spendingBankAccount.associateWithProduct(BankAccount.productType.loan, function (acct) {
          if (acct && acct instanceof BankAccount) {
            acct.verifyBankStatus(_this4._onSuccess.bind(_this4), _this4._onFailure.bind(_this4));
          }
        }, _this4._onFailure.bind(_this4));
      });
      this.presenter.addComputedVariable('pull_statement', null, function () {
        return true;
      });
      this.presenter.addComputedVariable('account_details', ['banking.accounts.bank_accounts[' + spendingAccountIndex + '].type', 'banking.accounts.bank_accounts[' + spendingAccountIndex + '].masked_account_number'], function (type, number) {
        return type + ' Account - ' + number;
      });
    } else if (this.spendingBankAccount.getActionRequired()) {
      this._pushAnalytics(true);
      this.presenter.addComputedVariable('edit_and_pull', null, function () {
        return true;
      });
      this.presenter.addComputedVariable('account_details', ['banking.accounts.bank_accounts[' + spendingAccountIndex + '].type', 'banking.accounts.bank_accounts[' + spendingAccountIndex + '].masked_account_number'], function (type, number) {
        return type + ' Account - ' + number;
      });
    } else {
      this._linkAndPullCallback(true);
    }
  };

  this._linkAndPullCallback = function (linkToCardAccount) {
    this._pushAnalytics(true);
    this.presenter.addComputedVariable('link_and_pull', null, function () {
      return true;
    });
    this._$plaidSupportedContent.removeClass('hide');
    this._$loader.remove();
  };

  this._dltSupportedCallback = function () {
    this._pushAnalytics(true);
    this.presenter.addComputedVariable('link_and_pull', null, function () {
      return true;
    });
    this._$plaidSupportedContent.addClass('hide');

    // Hide Plaid State
    this._$plaidSupportedContent.addClass('hide');
    // Show DLT state
    this._$dltSupportedContent.removeClass('hide');

    this._$loader.remove();
  };

  this._manualUploadCallback = function () {
    this._pushAnalytics(false);
    this.presenter.addComputedVariable('manual_upload', null, function () {
      return true;
    });

    this.presenter.updateDOM(this._$plaidSupportedContent);
    this._$plaidSupportedContent.removeClass('hide');
    this._$loader.remove();
  };

  // Click Connect Bank in DLT State
  this._onConnectBankViaDlt = function () {
    this._generateDLTCode();
  };

  this._selectNewBank = function (e) {
    e.preventDefault();
    this._forceRelink = this.presenter.getModelProperty('bankSelected.id');

    this._$verifySelectedBank.hide();
    this._removeComputed();
    if (!this._$checkBankComponent.mogo().create) {
      this._$checkBankComponent.show();
      // The 'show' method below is only for sending a page view analytics event.
      this._$checkBankComponent.mogo().show();
    } else {
      this._$checkBankComponent.mogo().create(this._CHECK_BANK_NAME, {
        presenter: this.presenter,
        onStatusOnline: this._newBankOnlineCallback.bind(this),
        onStatusOffline: this._newBankOfflineCallback.bind(this),
        onStatusNotSupported: this._newBankOfflineCallback.bind(this),
        onDltSupported: this._newBankDltSupportedCallback.bind(this),
        process: 'loan-bank-statement'
      });
    }
    this._$selectAnotherBankSection.show();
  };

  this._newBankDltSupportedCallback = function () {
    this._resetCheckBankUI();
    this._dltSupportedCallback();
    this._$verifySelectedBank.show();
  };

  this._newBankOnlineCallback = function () {
    this._resetCheckBankUI();
    this._linkAndPullCallback();
    this._$verifySelectedBank.show();
  };

  this._newBankOfflineCallback = function () {
    this._resetCheckBankUI();
    this._manualUploadCallback();
    this._$verifySelectedBank.show();
  };

  this._resetCheckBankUI = function () {
    this._$checkBankContinue = $('.js--check-bank');
    this._$checkBankSelections = $('.js--banking-institutions');
    this._$checkBankContinue.each(function () {
      $(this).mogo().removeDisabledLoadState();
    });
    this._$checkBankSelections.mogo().setSelectedIndex(0);
    this._$selectAnotherBankSection.hide(); // TODO: need to reset selection as well...
    this._$checkBankComponent.hide();

    // Hide DLT state (This is the initial state of page - hide class is present on DLT state markup in pug initially)
    // So when resetting hide class should be present on DLT state
    this._$dltSupportedContent.addClass('hide');
    this.presenter.updateDOM();
  };

  this._onSuccess = function () {
    var _this5 = this;

    this.getBankById(this.spendingBankAccount.bankId, function (bk) {
      _this5.analytics.pushEvent('abs-status', { ABSBank: [bk.getBankName()] });
      location.replace('/portal/dashboard');
    });
  };

  this._onFailure = function (errorData) {
    if (errorData.errors) {
      this.analytics.forcePushEvent('generic-api-response-error', {
        event: ['PlaidBankLinkOrVerifyResponse'],
        Code: [errorData.errors[0].code],
        Key: [errorData.errors[0].key],
        Msg: [errorData.errors[0].msg],
        Property: [errorData.errors[0].property]
      });
    }
    this.presenter.setModelProperty('banking.linkToAccountId', this.spendingBankAccount.id);
    this.history.goToUrl('/member/dashboard/loans/apply/bank-statement/error');
  };

  this._removeComputed = function () {
    this.presenter.removeComputedVariable('pull_statement');
    this.presenter.removeComputedVariable('link_and_pull');
    this.presenter.removeComputedVariable('manual_upload');
    this.presenter.removeComputedVariable('account_details');
  };

  // Function copied from else where;
  this._setupLivechat = function () {
    // scope variables because elements might not be visible yet
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");
    this._$liveChat = $('.js--live-chat');

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$liveChat.length > 0 && this._liveChatComponent.length === 0) {
      this._$liveChat.mogo().create('LiveChat', {
        presenter: this.presenter
      });
    } else if (this._liveChatComponent.length) {
      this._liveChatComponent.mogo().minimizeChatOnPage();
      this._liveChat = this._liveChatComponent;
    }
  };
}